import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=a4fbef68&scoped=true"
import script from "./AlertsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AlertsTable.vue?vue&type=style&index=0&id=a4fbef68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fbef68",
  null
  
)

export default component.exports